import { render, staticRenderFns } from "./left_side_mobile.vue?vue&type=template&id=3d2cd976&"
import script from "./left_side_mobile.vue?vue&type=script&lang=js&"
export * from "./left_side_mobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports